export const COMPANY_TYPE_DEF = "/CompanyTypeDef/GetAllCompanyTypeDef"
export const ADD_COMPANY_TYPE_DEF = "/CompanyTypeDef/InsertCompanyTypeDef" 
export const UPDATE_COMPANY_TYPE_DEF = "/CompanyTypeDef/UpdateCompanyTypeDef"
export const DELETE_COMPANY_TYPE_DEF = "/CompanyTypeDef/DeleteCompanyTypeDef"